import { FC } from 'react';
import { Show } from 'react-admin';

export const ServiceItemShow: FC = () => {
  return <Show>hi</Show>;
};
